<template>
  <div
    :class="`hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-${hubspotId}`"
    :data-hubspot-wrapper-cta-id="hubspotId"
    style="max-width: 100%; max-height: 100%"
  >
    <a :href="href" target="_blank" rel="noopener noreferrer">
      <img
        :alt="imgAlt || 'Logo'"
        loading="eager"
        fetchpriority="high"
        :src="optimizedSrc"
        :srcset="srcSet"
        sizes="(max-width: 1100px) 100vw, 1100px"
        @error="handleImageError"
        style="max-width: 100%; height: auto"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'HubspotCard',
  props: {
    hubspotId: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    imgSrc: {
      type: String,
      required: true,
    },
    imgAlt: {
      type: String,
      default: 'Logo',
    },
  },
  computed: {
    optimizedSrc() {
      return this.buildOptimizedUrl(this.imgSrc, { width: 1400, format: 'webp' })
    },
    srcSet() {
      const widths = [480, 960, 1400]
      const set = widths
        .map(width => `${this.buildOptimizedUrl(this.imgSrc, { width, format: 'webp' })} ${width}w`)
        .join(', ')
      return set || this.imgSrc
    },
  },
  methods: {
    initializeWebInteractives() {
      const existingScripts = [
        document.getElementById('hs-web-interactives-loader'),
        document.getElementById('hs-web-interactives-top-anchor'),
        document.getElementById('hs-web-interactives-top-push-anchor'),
        document.getElementById('hs-web-interactives-bottom-anchor'),
        document.getElementById('hs-web-interactives-floating-container'),
      ]
      existingScripts.forEach(script => {
        if (script) script.remove()
      })
      window.hubspot_web_interactives_running = false
      const script = document.createElement('script')
      script.id = 'hs-web-interactives-loader'
      script.src = 'https://js.hubspot.com/web-interactives-embed.js'
      script.async = true
      document.body.appendChild(script)
    },
    handleImageError(event) {
      event.target.style.display = 'none'
    },
    buildOptimizedUrl(src, params) {
      try {
        const url = new URL(src)
        Object.entries(params).forEach(([key, value]) => {
          url.searchParams.set(key, value)
        })
        return url.toString()
      } catch (e) {
        return src
      }
    },
  },
  mounted() {
    this.initializeWebInteractives()
  },
}
</script>
